import { render, staticRenderFns } from "./xeRankCardSetting.vue?vue&type=template&id=154f3e98"
import script from "./xeRankCardSetting.vue?vue&type=script&lang=js"
export * from "./xeRankCardSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports